export default "Fremstil jeres egne nemme og flotte sæler af genbrugspap og skab jeres egen lille sælkoloni!";